import { WebPlugin } from '@capacitor/core';
import { VoiceRecorderImpl } from './VoiceRecorderImpl';
import AudioRecorder from 'fpmk-simple-audio-recorder';
AudioRecorder.initWorker();
export class VoiceRecorderWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.recorder = new AudioRecorder({
            recordingGain: 1,
            encoderBitRate: 96,
            streaming: true,
            streamBufferSize: 128,
            // rather than at the end as one large blob
            constraints: {
                // Optional audio constraints, see https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
                channelCount: 1,
                autoGainControl: false,
                echoCancellation: false,
                noiseSuppression: false,
            },
        });
        this.voiceRecorderInstance = new VoiceRecorderImpl(this.recorder, this);
    }
    canDeviceVoiceRecord() {
        return VoiceRecorderImpl.canDeviceVoiceRecord();
    }
    hasAudioRecordingPermission() {
        return VoiceRecorderImpl.hasAudioRecordingPermission();
    }
    requestAudioRecordingPermission() {
        return VoiceRecorderImpl.requestAudioRecordingPermission();
    }
    startRecording() {
        return this.voiceRecorderInstance.startRecording();
    }
    stopRecording() {
        return this.voiceRecorderInstance.stopRecording();
    }
    pauseRecording() {
        return this.voiceRecorderInstance.pauseRecording();
    }
    resumeRecording() {
        return this.voiceRecorderInstance.resumeRecording();
    }
    getCurrentStatus() {
        return this.voiceRecorderInstance.getCurrentStatus();
    }
    addListener(eventName, listenerFunc) {
        return super.addListener(eventName, listenerFunc);
    }
}
//# sourceMappingURL=web.js.map